//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { setting_obj } from '~/settings/setting';
import { needXssKeys } from '~/utils/constants';
import { replaceToOriginStr, formatPath } from '@/utils/tools';

const statusObj = {
  1: {
    text: '审核中',
    class: 'processing',
  },
  2: {
    text: '审核未通过',
    class: 'failed',
  },
};
export default {
  props: {
    cardType: {
      type: String,
      default: 'feed',
    },
    type: {
      type: String,
      default: 'resource',
    },
    showMask: {
      type: Boolean,
      default: false,
    },
    pluginInfo: {
      type: Object,
      default() {
        return {};
      },
    },
    action_position: {
      type: String,
      validator(value) {
        // 这个值必须匹配下列字符串中的一个
        return ['search', 'community', 'profile', 'banner', 'morelikethis'].indexOf(value) !== -1;
      },
      default: 'community',
    },
    action_type: {
      type: String,
      default: '',
    },
    action_detail: {
      type: Number,
    },
  },
  data() {
    return {
      imageCdnPath: setting_obj.imageCdnPath,
    };
  },
  computed: {
    formatPluginInfo() {
      const info = { ...this.pluginInfo };
      const keys = Object.keys(info).filter((key) => needXssKeys.includes(key));
      ['plugin_logo', 'plugin_cover_url'].forEach((key) => {
        if (info[key]) {
          info[key] = formatPath(info[key], setting_obj.imageCdnPath);
        }
      });
      keys.forEach((key) => {
        if (!info[key]) return;
        if (Array.isArray(info[key])) {
          info[key] = info[key].map(replaceToOriginStr);
        } else if (typeof info[key] === 'string') {
          info[key] = replaceToOriginStr(info[key]);
        }
      });
      return info;
    },
    statusObj() {
      return statusObj[this.formatPluginInfo.status];
    },
    isShowView() {
      return this.cardType !== 'like' && !this.showMask;
    },
    isShowAuthor() {
      return this.cardType === 'feed';
    },
    coverUrl() {
      const { cover_url } = this.formatPluginInfo;
      const path = formatPath(cover_url, setting_obj.imageCdnPath);
      return path;
    },
  },
  methods: {
    goDetail() {
      if (this.formatPluginInfo.status) return;
      if (this.action_position) {
        const sensorParams = {
          action_position: this.action_position,
          plugin_id: this.formatPluginInfo.plugin_id,
          plugin_name: this.formatPluginInfo.plugin_name,
          action_detail: this.action_detail,
        };
        if (this.action_type) {
          sensorParams.action_type = this.action_type;
        }
        // 根据来源增加访问社区文件埋点
        this.$sensors.track('get_plugin', sensorParams);
      }
    },
    goUser() {
      const routeData = this.$router.resolve({
        name: 'profile-id',
        params: { id: this.formatPluginInfo.author_id },
        query: { tab: 'plugin' },
      });
      window.open(routeData.href, '_blank', 'noopener,noreferrer');
    },
    clickResource(e) {
      if (this.showMask) e.preventDefault();
    },
  },
};
